import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-av-full-card-summary',
  templateUrl: './av-full-card-summary.component.html',
  styleUrls: ['./av-full-card-summary.component.scss']
})
export class AvFullCardSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
